import { render, staticRenderFns } from "./ApplePromotionPopup.vue?vue&type=template&id=3678d5f3&scoped=true"
import script from "./ApplePromotionPopup.vue?vue&type=script&lang=js"
export * from "./ApplePromotionPopup.vue?vue&type=script&lang=js"
import style0 from "./ApplePromotionPopup.vue?vue&type=style&index=0&id=3678d5f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678d5f3",
  null
  
)

export default component.exports